import { Link } from "react-router-dom";

import thumbnailMap from "../../public/fps2026.png";
import paperPdf from "../../public/FPS2026.pdf";

const PAPER_PDF_URL = paperPdf;

function PublicationsDesktop() {
  return (
    <section id="blog" className="pt-[80px] mb-[30px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-[24px] font-medium mb-8">Publications</p>
        </div>

        <div className="flex flex-row items-center gap-8">
          <div className="mb-4 mr-20">
            <div className="flex flex-row text-[18px] ">
              <p className="font-medium mr-2">
                On the Security of Agentic Pull Requests in GitHub: An Empirical
                Study
              </p>

              <a href={PAPER_PDF_URL} target="_blank" rel="noopener noreferrer">
                <div className="flex font-[300] text-custom-green">
                  <p className="text-[20px]">[</p>
                  <div className="underline underline-offset-2 font-[300] ">
                    PDF
                  </div>
                  <p className="text-[20px]">]</p>
                </div>
              </a>
            </div>
            <p className="mt-2">
              <span className="">Minh Le, </span>
              <span className="text-gray-4">
                Thanoshan Vijayanand, Gouri Ginde, Benjamin Tan, Lorenzo De
                Carli
              </span>
            </p>
            <p className="mt-2 text-gray-4 text-[16px]">
              FPS 2026 - 19th International Symposium on Foundations & Practice
              of Security
            </p>
          </div>

          <div className="w-[190px] h-[95px] overflow-hidden bg-white rounded-lg mb-6 mt-3 flex items-center justify-center">
            <img
              src={thumbnailMap}
              alt="thumbnail"
              className="object-cover w-[100%] h-[100%]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PublicationsDesktop;
